import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import MoveMEoutWrapper from "@components/layouts/moveMEoutWrapper";

export default function MoveMEoutHome(): ReactElement {
    return (
        <MoveMEoutWrapper>
            <PrivacyPolicy domain="movemeout.com" category="Moving Services" />
        </MoveMEoutWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
